import React, { useState } from 'react'
import { logos } from '../../assets'
import { CustomModal } from '../../components'
import ModalAddEnterprise from './ModalAddEnterprise'

export const HeaderAdmin = () => {
    const [modalAddEntrprise, setModalAddEntrprise] = useState(false)
    return (
        <div className="z-50 fixed top-0 left-0 w-full h-16 bg-1B1464 flex items-center shadow-lg">
            <div className='w-3/12 h-full  flex items-center'>
                <img className='h-9 ml-4 object-contain' src={logos.inmersysLogin} alt="inmersyslogo" />
            </div>
            <div className='w-5/12 h-full  flex justify-start items-center'>
                <div className='px-4 cursor-pointer'>
                    <p className='text-white text-base'> VR Learning </p>
                    <div className='mt-1 w-full h-px bg-white'></div>
                </div>
                <div className='px-4 cursor-pointer'>
                    <p className='text-white text-base'> VR Training </p>
                    {/* <div className='mt-1 w-full h-px bg-white'></div> */}
                </div>
            </div>
            <div className='w-4/12 flex justify-end items-center pr-4'>
                <button
                    onClick={() => setModalAddEntrprise(true)}
                    className='w-[236px] h-12 text-white text-center bg-btn hover:bg-btnHover focus:bg-btnPressed'>
                    Agregar empresa</button>
            </div>
            <CustomModal
                width={430} height={616}
                isVisible={modalAddEntrprise} title='Agregar nueva empresa' close={() => setModalAddEntrprise(false)}>
                <ModalAddEnterprise closeModal={() => setModalAddEntrprise(false)}></ModalAddEnterprise>
            </CustomModal>
        </div>
    )
}

export default HeaderAdmin